var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"field__label flex items-center justify-between"},[_c('label',{staticClass:"field__label__text block text-xs mb-2",attrs:{"for":_vm.field.attributes.slug},domProps:{"textContent":_vm._s(_vm.field.attributes.label)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }